// @ts-check
import SimpleTable from 'components/Common/SimpleTable/SimpleTable';
import React, { useCallback } from 'react';

/**
 * Data type for the example data
 * @typedef {object} ExampleDataType
 * @prop {string} id
 * @prop {string} name
 * @prop {number} age
 * @prop {string} address
 * @prop {string} [extra]
 */

/**
 * @type {ExampleDataType[]}
 */
const data = [...Array(20)].map((unused, index) => ({
  id: index.toString(),
  name: 'name' + index,
  age: 32 + Math.random() * 10,
  address: 'address' + index
}));

/**
 * @type {import('components/Common/SimpleTable/SimpleTable').ColumnType<ExampleDataType>[]}
 */
const columns = [
  {
    label: 'Id',
    path: 'id',
    isSortable: true
  },
  {
    label: 'Name',
    path: 'name',
    isSortable: true,
    searchItem: true
  },
  {
    label: 'Age',
    path: 'age',
    isSortable: true
  },
  {
    label: 'Address',
    path: 'address',
    isSortable: true
  },
  {
    label: 'Extra data',
    path: 'extra',
    isSortable: true
  }
];

/**
 * @type {import('components/Common/SimpleTable/SimpleTable').SortByType<ExampleDataType>}
 */
const DefaultSortBy = {
  path: 'name',
  direction: 'desc'
};

const SimpleTablePagedExample = () => {

  // eslint-disable-next-line no-console
  const onClickRow = useCallback(row => console.log('row', row), []);

  return (
    <SimpleTable
      columns={columns}
      data={data}
      sortBy={DefaultSortBy}
      onRowClick={onClickRow}
      usePaging
      pageSize={5}
    />
  );
};
export default SimpleTablePagedExample;
